
import React from 'react';
import './CalorieCalculator.css';
import EntryForm from './EntryForm';

function CalorieCalculator(){
    return (
      <div>
      <EntryForm />
      </div>
    );
  
}

export default CalorieCalculator;
